import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

export interface ModalState {
  modals: React.ReactNode[];
  isLoading: boolean;
}
const initialState: ModalState = {
  modals: [],
  isLoading: false,
};
const modalSlice = createSlice({
  name: "Modal",
  initialState,
  reducers: {
    addModal: (
      state,
      action: PayloadAction<React.ReactNode | React.ReactElement>
    ) => {
      state.modals.push(action.payload);
    },
    removeModal: (state) => {
      state.modals.pop();
    },
    clearModal: (state) => {
      state.modals.splice(0);
    },
    setLoading: (state) => {
      state.isLoading = !state.isLoading;
    },
  },
});
const { actions, reducer } = modalSlice;
export const { addModal, removeModal, clearModal, setLoading } = actions;

export default reducer;
